import { render, staticRenderFns } from "./Sending.vue?vue&type=template&id=fb74320a&scoped=true"
import script from "./Sending.vue?vue&type=script&lang=js"
export * from "./Sending.vue?vue&type=script&lang=js"
import style0 from "./Sending.vue?vue&type=style&index=0&id=fb74320a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb74320a",
  null
  
)

export default component.exports